import React from "react";
import classes from "./ExpirationBadge.module.scss";

const ExpirationBadge = ({ label }) => (
  <span className={classes.ExpirationBadge}>{label}</span>
);

export default ExpirationBadge;
